function pathOnly(pathname) {
  if (!pathname || typeof pathname !== "string") return "";
  return pathname.split("?")[0];
}

/**
 * Live-feed test URLs: Sign In / Subscribe in the header are shown here (and site-wide rollout is controlled separately).
 */
export function showNavAuthTestOnPath(pathname) {
  const p = pathOnly(pathname);
  if (!p) return false;
  return (
    p === "/live-streams" ||
    p.startsWith("/live-streams/") ||
    p === "/live-feeds" ||
    p.startsWith("/live-feeds/") ||
    p === "/demo-live-feeds" ||
    p.startsWith("/demo-live-feeds/")
  );
}

function isMembersAreaPath(p) {
  return (
    p === "/members-area" ||
    p.startsWith("/members-area/") ||
    p === "/member-area" ||
    p.startsWith("/member-area/")
  );
}

function isLoginPath(p) {
  return p === "/login" || p.startsWith("/login/");
}

/**
 * Where guest Sign In / Subscribe (and related header layout) should appear — live-feed test URLs,
 * members-area routes, and /login (e.g. after RequireAuth redirect from members-area).
 */
export function showGuestAuthNavOnPath(pathname) {
  const p = pathOnly(pathname);
  if (!p) return false;
  return (
    showNavAuthTestOnPath(pathname) ||
    isMembersAreaPath(p) ||
    isLoginPath(p)
  );
}
